module.exports = __webpack_public_path__ + "img/locate-vending-machine-footer-old.cc89fe54.png";